import {
    IconButton, Modal, ModalOverlay, ModalContent,
    ModalHeader, ModalBody, ModalFooter, ModalCloseButton,
    Button, useDisclosure, Textarea, useToast,
    Icon, Text,
    Box, Select, Flex,
    VStack
} from "@chakra-ui/react";
import { MdAutoAwesome } from "react-icons/md";
import { useState } from "react";
import axios from '../utils/axiosConfig';
import { keyframes } from '@emotion/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useEffect } from "react";

// Define spin animation
const spin = keyframes`
  from { transform: rotateY(0deg); }
  to { transform: rotateY(360deg); }
`;

function GenerateInstruction({ onGenerate, generating, setGenerating, models }) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [prompt, setPrompt] = useState("");

    const initialModelValue =
        models?.find(m => m.useForAIInstructionsGeneration)?.value ?? "";
    console.log(initialModelValue);

    const [selectedModel, setSelectedModel] = useState(initialModelValue);

    useEffect(() => {
        const first = models?.find(m => m.useForAIInstructionsGeneration)?.value;
        if (first) setSelectedModel(first);
    }, [models]);

    const toast = useToast();

    const handleGenerate = async () => {
        setGenerating(true);
        onClose();
        try {
            const response = await axios.post(
                '/api/protected/assistants/generate-instruction/',
                {
                    prompt: prompt.trim(),
                    model: selectedModel
                },
                { headers: { 'Content-Type': 'application/json' } }
            );

            const data = response.data;

            onGenerate(data.instruction); // send back to parent
            toast({
                title: "Instruction generated!",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
            setPrompt(""); // Clear the prompt after successful generation

        } catch (error) {
            toast({
                title: "Error generating instruction.",
                description: error.message,
                status: "error",
                duration: 4000,
                isClosable: true,
            });
        } finally {
            setGenerating(false);
        }
    };

    return (
        <>
            <Box mb={4} display="flex" alignItems="center">
                <Button
                    leftIcon={
                        <Icon
                            as={MdAutoAwesome}
                            animation={generating ? `${spin} 1s linear infinite` : undefined}
                        />
                    }
                    onClick={onOpen}
                >
                    Generate
                </Button>
            </Box>

            <Modal isOpen={isOpen} onClose={onClose} size="lg">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Generate AI Instruction</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <VStack align="start" mb={4}>

                            <Select
                                value={selectedModel}
                                onChange={(e) => setSelectedModel(e.target.value)}
                                isDisabled={!models?.some(m => m.useForAIInstructionsGeneration)}
                            >
                                {models
                                    ?.filter((m) => m.useForAIInstructionsGeneration === true)
                                    .map((m) => (
                                        <option key={m._id} value={m.value}>
                                            {m.name}
                                        </option>
                                    ))}
                            </Select>
                            <Textarea
                                placeholder="What should your AI Bot be instructed to do?"
                                value={prompt}
                                onChange={(e) => setPrompt(e.target.value)}
                                mb={4}
                                isDisabled={generating}
                            />
                        </VStack>
                    </ModalBody>

                    <ModalFooter>
                        <Button onClick={onClose} mr={3} variant="ghost" isDisabled={generating}>
                            Cancel
                        </Button>
                        <Button
                            colorScheme="blue"
                            onClick={handleGenerate}
                            isLoading={generating}
                            isDisabled={!prompt.trim()}
                        >
                            Generate
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
}

export default GenerateInstruction;